import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { getClassNameFactory } from "@dcl/ui";
import { IPosition } from "./StickyProps"; // sticky shell utility component

export var Sticky = function Sticky(_ref) {
  var boundaryQuerySelector = _ref.boundaryQuerySelector,
      targetPosition = _ref.targetPosition,
      fixed = _ref.fixed,
      className = _ref.className,
      children = _ref.children;
  var ref = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      targetOffset = _useState2[0],
      setTargetOffset = _useState2[1];

  var onScrollChange = useCallback(function () {
    var target = document.querySelector(boundaryQuerySelector);

    if (target) {
      var targetHeight = target.clientHeight || 0;
      var targetBounding = target.getBoundingClientRect() || {};
      var viewHeight = window.innerHeight;
      var offset = targetBounding[targetPosition] || 0;

      if (targetPosition === IPosition.TOP) {
        offset = viewHeight - targetBounding[IPosition.BOTTOM] + targetHeight;
      }

      var isInView = false;

      if (fixed === IPosition.BOTTOM) {
        isInView = targetBounding[IPosition.TOP] <= viewHeight || false;
      }

      if (fixed === IPosition.TOP) {
        isInView = targetBounding[IPosition.BOTTOM] > 0;
      }

      if (isInView) {
        setTargetOffset(offset);
      } else {
        setTargetOffset(0);
      }
    }
  }, [boundaryQuerySelector, fixed, targetPosition]);
  var onActiveElementChange = useCallback(function () {
    var activeElement = document.activeElement;
    var sticky = ref ? ref.current : null;

    if (activeElement && sticky) {
      var positionActiveElement = activeElement.getBoundingClientRect();
      var positionSticky = sticky.getBoundingClientRect();

      if (positionSticky && (positionActiveElement.bottom > positionSticky.top || positionActiveElement.top > positionSticky.bottom)) {
        activeElement.scrollIntoView();
      }
    }
  }, [document.activeElement, ref]);
  useEffect(function () {
    onScrollChange();
    onActiveElementChange();
    window.addEventListener("keyup", onActiveElementChange);
    window.addEventListener("scroll", onScrollChange);
    return function () {
      window.removeEventListener("keyup", onActiveElementChange);
      window.removeEventListener("scroll", onScrollChange);
    };
  }, [onScrollChange, onActiveElementChange]);
  var getClassName = getClassNameFactory(Sticky.displayName);

  var style = _defineProperty({}, fixed, targetOffset);

  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: getClassName({
      className: className,
      modifiers: fixed
    }),
    style: style
  }, children);
};
Sticky.displayName = "Sticky";
export default Sticky;